<div class="field mb-2">
  <label *ngIf="options.label" for="">{{ options.label | translate }}</label>
  <p-multiSelect
    [options]="options.dropdownOptions"
    [optionLabel]="options.optionLabel"
    [placeholder]="options.placeholder"
    [formControlName]="options.formControlName"
    [optionValue]="options.optionValue"
    styleClass="w-full"
    (onChange)="onChangeValue($event)"
    display="chip"
  >
  </p-multiSelect>
</div>
